import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { Url } from '../types.tsx';

export const getIssueUrl = (issueKey: IssueKey): Url => `/browse/${issueKey}`;
